import { gql } from '@apollo/client';

export const GET_TENANTS = gql`
  query GetTenants {
    tenants {
      name
      code
      id
      type
      commission
      maxBonus
      duplicateThreshold
      rateChangeThreshold1
      rateChangeThreshold2
      rateChangeThreshold3
      currency
      logo
      receiptLabel
      receiptLineOne
      receiptLineTwo
      receiptFootnote
      rates {
        id
        code
        source
        destination
        rate
      }
      status
    }
  }
`;

export const GET_TENANT = gql`
  query GetTenant($tenantId: ID!) {
    tenant(id: $tenantId) {
      name
      code
      id
      type
      commission
      maxBonus
      duplicateThreshold
      rateChangeThreshold1
      rateChangeThreshold2
      rateChangeThreshold3
      currency
      logo
      receiptLabel
      receiptLineOne
      receiptLineTwo
      receiptFootnote
      rates {
        id
        code
        source
        destination
        rate
      }
      status
    }
  }
`;

export const ADD_TENANT = gql`
  mutation AddTenant(
    $code: String!
    $name: String!
    $type: String!
    $currency: String!
    $commission: Float!
    $duplicateThreshold: Int!
    $rateChangeThreshold1: Int
    $rateChangeThreshold2: Int
    $rateChangeThreshold3: Int
    $maxBonus: Int!
    $logo: String
    $receiptLabel: String!
    $receiptLineOne: String
    $receiptLineTwo: String
    $receiptFootnote: String
  ) {
    addTenant(
      code: $code
      name: $name
      type: $type
      currency: $currency
      commission: $commission
      duplicateThreshold: $duplicateThreshold
      rateChangeThreshold1: $rateChangeThreshold1
      rateChangeThreshold2: $rateChangeThreshold2
      rateChangeThreshold3: $rateChangeThreshold3
      maxBonus: $maxBonus
      logo: $logo
      receiptLabel: $receiptLabel
      receiptLineOne: $receiptLineOne
      receiptLineTwo: $receiptLineTwo
      receiptFootnote: $receiptFootnote
    ) {
      success
      code
      tenant {
        name
        code
        type
        id
        commission
        maxBonus
        duplicateThreshold
        rateChangeThreshold1
        rateChangeThreshold2
        rateChangeThreshold3
        currency
        logo
        receiptLabel
        receiptLineOne
        receiptLineTwo
        receiptFootnote
      }
    }
  }
`;

export const UPDATE_TENANT = gql`
  mutation UpdateTenant(
    $id: ID!
    $name: String
    $code: String
    $type: String
    $currency: String
    $commission: Float
    $duplicateThreshold: Int
    $rateChangeThreshold1: Int
    $rateChangeThreshold2: Int
    $rateChangeThreshold3: Int
    $maxBonus: Int
    $receiptLabel: String
    $receiptLineOne: String
    $receiptLineTwo: String
    $receiptFootnote: String
    $logo: String
  ) {
    updateTenant(
      id: $id
      name: $name
      code: $code
      type: $type
      currency: $currency
      commission: $commission
      duplicateThreshold: $duplicateThreshold
      rateChangeThreshold1: $rateChangeThreshold1
      rateChangeThreshold2: $rateChangeThreshold2
      rateChangeThreshold3: $rateChangeThreshold3
      maxBonus: $maxBonus
      receiptLabel: $receiptLabel
      receiptLineOne: $receiptLineOne
      receiptLineTwo: $receiptLineTwo
      receiptFootnote: $receiptFootnote
      logo: $logo
    ) {
      code
      message
      success
      tenant {
        name
        code
        id
        type
        commission
        maxBonus
        duplicateThreshold
        rateChangeThreshold1
        rateChangeThreshold2
        rateChangeThreshold3
        currency
        logo
        receiptLabel
        receiptLineOne
        receiptLineTwo
        receiptFootnote
      }
    }
  }
`;
